import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * Cuenta regresiva (segundos) que baja sola; 0 = ya se puede. Para los 429 de Meta: nunca se
 * reintenta solo, el botón queda en gris hasta que llega a 0.
 * @returns {{ left: number, start: (seconds: number) => void, reset: () => void }}
 */
export function useMetaCountdown() {
  const [left, setLeft] = useState(0);
  const untilRef = useRef(0);
  useEffect(() => {
    if (left <= 0) return undefined;
    const id = setInterval(() => {
      const next = Math.max(0, Math.ceil((untilRef.current - Date.now()) / 1000));
      setLeft(next);
    }, 1000);
    return () => clearInterval(id);
  }, [left]);
  const start = useCallback((seconds) => {
    untilRef.current = Date.now() + seconds * 1000;
    setLeft(seconds);
  }, []);
  const reset = useCallback(() => { untilRef.current = 0; setLeft(0); }, []);
  return { left, start, reset };
}

export default useMetaCountdown;
